export enum SEU_DATE_FORMAT {
  DATE = 'dd.MM.yyyy',
  ELAPSED = 'ELAPSED',
}

export type SeuDateApi = string & { _brand: 'date_api' };
